export default __webpack_public_path__ + "static/media/06.1c554057.jpg";